import actions from './actions';
import mutations from './mutations';

const state = {
  slides: [],
  archSlides: [],
  featSlides: [],
  suiteDetails: {
    cityscape: [],
    sealoge: [],
    skye: [],
    summer: []
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/amenities/index.js